var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subGroup)?_c('div',[_c('div',{staticClass:"rkm-sidebar-list"},[_c('div',{staticClass:"rkm-sidebar-list-wrap"},[_vm._t("default")],2)])]):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }